import * as icons from 'ionicons/icons';

export const ConfigService = {

    getMenuOptions: async () => {

        try {
            
            const resp = await fetch('assets/config/menu.json');
            const options = await resp.json();
            
            return options.map(menu => {

                return {

                    ...menu,
                    icon: icons[menu.icon]
                };
            });

        } catch (error) {
            
            return [];
        }
    },

    setIconsOptions: (items = []) => {

        try {
            
            return items.map(menu => {

                return {

                    ...menu,
                    icon: icons[menu.icon]
                };
            });

        } catch (error) {
            
            return [];
        }
    }
};